var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M10 0c5.5 0 10 4.5 10 10s-4.5 10-10 10S0 15.5 0 10 4.5 0 10 0zm5.5 14.5l-3.1-3.1c.6-.7.8-1.7.8-2.6 0-2.4-2-4.4-4.4-4.4s-4.4 2-4.4 4.4c0 2.4 2 4.4 4.4 4.4.9 0 1.8-.3 2.6-.8l3.1 3.1c.1.1.3.2.5.2s.4-.1.5-.2c.3-.2.3-.7 0-1zM6.7 11c-1.2-1.2-1.2-3.1 0-4.2.6-.6 1.3-.9 2.1-.9 1.7 0 3 1.3 3 3s-1.3 3-3 3c-.7 0-1.5-.4-2.1-.9z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/SearchWithCircle.svg